import React from "react";
import loader from "../../components/loader/loader";
import { APIURL } from "../../redux/action/config";
import NoImage from "../../assets/images/noimages.jpg";

const ViewVehicle = ({ viewDetails, modalId }) => {
  const vehicleDetails = viewDetails?.data ? viewDetails?.data?.vehicle : "";

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && vehicleDetails?.id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">Vehicle Detail</h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Vehicle Image</span>
                        </label>
                        <div>
                          <img
                            className="mw-150px"
                            src={
                              vehicleDetails.image
                                ? APIURL + "/" + vehicleDetails.image
                                : NoImage
                            }
                            alt="vehicle image"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Vehicle Name </span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.name ? vehicleDetails?.name : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Vehicle Model</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.vehicle_model
                            ? vehicleDetails?.vehicle_model
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.price
                            ? vehicleDetails?.price
                            : "N/A"}
                        </div>
                      </div>

                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Per Week Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.perWeekPrice
                            ? vehicleDetails?.perWeekPrice
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Registration No</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.registration_no
                            ? vehicleDetails?.registration_no
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Color</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.color
                            ? vehicleDetails?.color
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Year</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {vehicleDetails?.year ? vehicleDetails?.year : "N/A"}
                        </div>
                      </div>
                    </div>
                    {/*  */}

                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Booking Status</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          <span
                            className={`btn ${
                              vehicleDetails.isBooked === "booked"
                                ? "success"
                                : "secondary"
                            } text-capitalize`}
                          >
                            {vehicleDetails.isBooked}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Status</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          <span
                            className={`btn ${
                              vehicleDetails.status === "active"
                                ? "success"
                                : "secondary"
                            } text-capitalize`}
                          >
                            {vehicleDetails.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </form>
                ) : (
                  loader()
                )}

                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewVehicle;
